import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../App.css';

import { Link, useParams } from 'react-router-dom'; 
import Sidebar from '../../Sidebar';
  


function DeleteAccount(){
    const [items, setItems] = useState([]);
    
    const pathSegments = window.location.pathname.split("/"); 
  const lastSegment = pathSegments[pathSegments.length - 1]; 
    const [isEnglish, setIsEnglish,getIsEnglish] = useState(sessionStorage.getItem("language_index") != null && sessionStorage.getItem("language_index") == 1);
    useEffect(() => {
     
      axios.get('/backend/home.php', {
        headers: {
            'Custom-type': 'service3',
            'Content-Type': 'application/json',  // Beispiel für Content-Type
            // Weitere Header können hier hinzugefügt werden
        }
    })
    .then(response => {
        setItems(response.data);
    })
    .catch(error => {
        console.error('Es gab einen Fehler beim Abrufen der Daten:', error);
    });
    
    }
    , []);// Leer, d.h. dieser Effekt wird nur einmal nach dem initialen Rendern ausgeführt

    useEffect(() => {
       LanguageChange();
      }, [items]);// Dieser Effekt wird nur ausgeführt, wenn sich `items` ändert
       const LanguageChange = () => {
              const languageIndex = sessionStorage.getItem("language_index");
           setIsEnglish(languageIndex != null && languageIndex == 1);
           var isEnglish=languageIndex != null && languageIndex == 1;
         var topic =    document.getElementById("topic_header");
          if (lastSegment === "vulpio") {
               topic.innerText = isEnglish ?  "Account deletion – Vulpio" : "Konto löschen – Vulpio";
          }
         
       }
const WhichPP = () => {
  if(lastSegment == "vulpio") {
    return isEnglish ? <DeleteAccountVulpioEN/> : <DeleteAccountVulpioDE  />;
  }else{
     return <div></div>;
  }
};

const DeleteAccountVulpioDE = () => {
  return (
    <div>
      <p>
        Wenn du deinen <strong>Vulpio</strong>-Account löschen möchtest, kannst du das direkt in der App
        durchführen. Bitte beachte, dass die Löschung dauerhaft ist und dein Account inklusive der zugehörigen
        Accountdaten entfernt wird.
      </p>

      <h2>Account in der App löschen</h2>
      <ol>
        <li>Melde dich in der Vulpio-App mit dem Account an, den du löschen möchtest.</li>
        <li>Öffne den <strong>Profil</strong>-Reiter.</li>
        <li>Tippe oben rechts auf das <strong>Einstellungs-Zahnrad</strong>.</li>
        <li>Gehe zum Menüpunkt <strong>Profil</strong>.</li>
        <li>Tippe auf <strong>Account löschen</strong>.</li>
        <li>Bestätige die Löschung, indem du dein <strong>Passwort erneut eingibst</strong>.</li>
      </ol>

      <h2>Bestätigung</h2>
      <p>
        Nach der Bestätigung wird dein Vulpio-Account inklusive deiner Accountdaten erfolgreich entfernt.
      </p>

      <h2>Hinweis</h2>
      <p>
        Falls du dich nicht mehr anmelden kannst und Unterstützung benötigst, kontaktiere uns bitte unter
        <strong> info@finnmikoschek.de</strong>.
      </p>
    </div>
  );
};

const DeleteAccountVulpioEN = () => {
  return (
    <div>
      <p>
        If you want to delete your <strong>Vulpio</strong> account, you can do so directly in the app.
        Please note that deletion is permanent and your account, including associated account data, will be removed.
      </p>

      <h2>Delete your account in the app</h2>
      <ol>
        <li>Sign in to the Vulpio app using the account you want to delete.</li>
        <li>Open the <strong>Profile</strong> tab.</li>
        <li>Tap the <strong>Settings</strong> icon in the top right corner.</li>
        <li>Go to <strong>Profile</strong>.</li>
        <li>Tap <strong>Delete account</strong>.</li>
        <li>Confirm the deletion by <strong>entering your password again</strong>.</li>
      </ol>

      <h2>Confirmation</h2>
      <p>
        After confirmation, your Vulpio account and associated account data will be successfully removed.
      </p>

      <h2>Note</h2>
      <p>
        If you can no longer access your account and need assistance, please contact us at
        <strong> info@finnmikoschek.de</strong>.
      </p>
    </div>
  );
};

    return(
        <div><Sidebar onLanguageChange={LanguageChange}/>
                <div class="App-header">
            <div class="img_header">
                <h1 id='topic_header'></h1>
                <p id='text_header'></p>
                <img src="/images/web_app_header.webp"></img></div>
            <div class="text_container" id="service-container">
            
            <div class="text_container_data">
            <WhichPP />
                </div>
                </div>
            </div>
        </div>

    );

}

export default DeleteAccount;